import {
	ScrollView,
} from 'react-native';

export default ScrollView;



